import React from 'react';
import { Card } from 'antd';
import { SkBar, SkTabsBar, SkChartCard } from './_primitives';

const AnalyticsHeader = () => (
  <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-3 mb-4 sm:mb-6">
    <div className="flex flex-col gap-2 min-w-0 flex-1">
      <SkBar h="h-7" w="w-64" className="max-w-full" />
      <SkBar h="h-3" w="w-72" className="max-w-full" />
    </div>
    <div className="flex gap-2 flex-shrink-0">
      <SkBar h="h-9" w="w-32" className="rounded-md" />
      <SkBar h="h-9" w="w-32" className="rounded-md" />
    </div>
  </div>
);

const MetricCard = () => (
  <Card className="shadow-sm" styles={{ body: { padding: 16 } }}>
    <div className="flex items-center gap-3 min-w-0">
      <div className="w-11 h-11 rounded-lg bg-gray-200 animate-pulse flex-shrink-0" />
      <div className="flex-1 min-w-0 flex flex-col gap-2">
        <SkBar h="h-3" w="w-28" />
        <SkBar h="h-6" w="w-20" />
      </div>
    </div>
  </Card>
);

/**
 * AnalyticsPageLoader — matches the Analytics page layout:
 *  header (title/subtitle · range-select + export) ·
 *  4 metric cards (icon left, label + value) ·
 *  tabbed card → 2-col charts (area + donut) + full-width line chart.
 */
const AnalyticsPageLoader = () => (
  <div className="w-full p-3 sm:p-4 md:p-6">
    <AnalyticsHeader />

    {/* 4 metric cards */}
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mb-4 sm:mb-6">
      {Array.from({ length: 4 }).map((_, i) => (
        <MetricCard key={i} />
      ))}
    </div>

    {/* Tabbed card with charts */}
    <Card className="shadow-sm" styles={{ body: { padding: 20 } }}>
      <SkTabsBar tabs={5} />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 sm:gap-4 mb-4 sm:mb-6">
        <SkChartCard heightClass="h-60 sm:h-64 md:h-72" />
        <SkChartCard heightClass="h-60 sm:h-64 md:h-72" />
      </div>
      <SkChartCard heightClass="h-52 sm:h-56 md:h-64" />
    </Card>
  </div>
);

export default AnalyticsPageLoader;
